const TR_KEY_PREFIX = 'XSS_BRIEFING_FIELD';

export const formatValidationErrors = (x1Errors, formatMessage) => {
  return x1Errors.reduce((validationErrors, { field, errors }) => {
    const trKey = `${TR_KEY_PREFIX}_${field}`.toUpperCase();

    const humanPresentableField = formatMessage({ id: trKey });
    validationErrors[field] = formatMessage(
      {
        id: errors[0].localizationKey,
      },
      { field: humanPresentableField },
    );
    return validationErrors;
  }, {});
};

export const badX1Request = new Error(
  'Bad X1 Request - Neither success nor error',
);
